import axios from 'axios';
import ApiClient from './ApiClient';

class WhatsappMessageEditsAPI extends ApiClient {
  constructor() {
    super('whatsapp_qr', { accountScoped: true });
  }

  edit(messageId, content, requestId) {
    return axios.post(`${this.url}/messages/${messageId}/edit`, {
      content,
      request_id: requestId,
    });
  }
}

export default new WhatsappMessageEditsAPI();
